import { Component, OnInit, Inject, Input, Output, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { GestockService } from '../services/gestock.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';


@Component({
  selector: 'app-add-product-dialog',
  templateUrl: './add-product-dialog.component.html',
  styleUrls: ['./add-product-dialog.component.css']
})
export class AddProductDialogComponent implements OnInit {

  product = {
    id: 0,
    name: '',
    quantity: {},
    entryPrice: 0,
    prices: { gros: 0, demiGros: 0, detail: 0 },
    category: '',
    description: '',
    audioUrl: '',
    imageUrl: '',
  };

  makepost = 0;

  toutesLesCategories: string[] = [];
  newCategory: string = '';

  selectedCategorie: any;

  retourClientWS: any;

  etatreq = "";
  doneCreating = 0;


  //selectedCategories: string[] = [];

  samacaabiyoonwii = "";

  nomcateg: any;

  profil = "";
  nomdepot: any;
  adressedepot: any;
  selectedBoutiqueDepot: any;
  toutesLesBoutiques: any[] = [];


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef: any;


  constructor(private dialogRef: MatDialogRef<AddProductDialogComponent>,
    private configServer: GestockService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.profil = sessionStorage.getItem("profil");
    this.getAllCategories();
    this.getAllPoints();
  }


  makeCategorie() {
    if (this.nomcateg != undefined) {
      this.openSpinnerDialog();
      this.configServer.addCategorie(this.samacaabiyoonwii, this.nomcateg).then((retourbi) => {
        this.closeSpinnerDialog();
        console.log(retourbi);
        this.retourClientWS = retourbi;
        var statutreq = this.retourClientWS.statutreq;

        if (statutreq == 1) {
          this.etatreq = "successful";
          //this.getAllCategories() ;
        }
        else {
          this.etatreq = "failed";
          console.log("Failed");
        }
        this.dialogRef.close();
      });
    }
  }


  makeProduit() {
    if (this.product.name != undefined) {
      this.openSpinnerDialog();
      this.product.category = this.selectedCategorie;
      let leNouveauProduit = JSON.stringify(this.product);
      this.configServer.addProduct(this.samacaabiyoonwii, leNouveauProduit).then((retourbi) => {

        this.closeSpinnerDialog();
        console.log(retourbi);
        this.retourClientWS = retourbi;
        var statutreq = this.retourClientWS.statutreq;
        if (statutreq == 1) {
          this.etatreq = "successful";
          console.log("Done");
        }
        else {
          this.etatreq = "failed";
          console.log("Failed");
        }
        this.dialogRef.close(this.product);
      });
    }
  }

  getBoutiqueInfos() {
    for (let i = 0; i < this.toutesLesBoutiques.length; i++) {
      if (this.toutesLesBoutiques[i].idPoint == this.selectedBoutiqueDepot) {
        return this.toutesLesBoutiques[i];
      }
    }
  }

  makeDepot() {
    if (this.nomdepot != undefined && this.selectedBoutiqueDepot != undefined && this.adressedepot != undefined) {
      this.openSpinnerDialog();
      this.configServer.creerDepotForBoutique(this.samacaabiyoonwii, this.nomdepot, this.getBoutiqueInfos(), this.adressedepot).then((retourbi) => {
        this.closeSpinnerDialog();
        console.log(retourbi);
        this.retourClientWS = retourbi;
        var statutreq = this.retourClientWS.statutreq;
        if (statutreq == 1) {
          this.etatreq = "successful";
          console.log("Done");
        }
        else {
          this.etatreq = "failed";
          console.log("Failed");
        }
        this.dialogRef.close();
      });
    }
  }


  getAllCategories() {
    this.configServer.getAllCategories(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        this.toutesLesCategories = this.retourClientWS.data;
        console.log("Done");
      }
      else {
        console.log("Failed");
      }
    });
  }

  getAllPoints() {
    this.configServer.getAllPoints(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        this.toutesLesBoutiques = this.retourClientWS.data;
      }
      else {
        this.toutesLesBoutiques = [];
        console.log("Failed");
      }
    });
  }


  saisieconforme(formNumero) {
    if (formNumero == 1) {
      return (this.product.name != undefined &&
        this.selectedCategorie != undefined);
    } else
      if (formNumero == 2)
        return (this.nomcateg != undefined);
      else
        if (formNumero == 3)
          return (this.nomdepot != undefined && this.selectedBoutiqueDepot != undefined && this.adressedepot != undefined);
        else
          return false;
  }



  save() {
    this.dialogRef.close(this.product);
  }

  close() {
    this.dialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}
